import S from './NavBar.module.css'
import L from '../images/hooshyarDam.png'
import farm from '../images/farmic2.jpg'
import { useEffect, useState } from 'react'
import SideBar from './SideBar'
import { useGlobalContext } from './Context'
import AddAlarmIcon from '@mui/icons-material/AddAlarm';
import { useDispatch, useSelector } from 'react-redux'
import {   ExitToAppRounded, Logout, PowerSettingsNew, ReportGmailerrorred, Search, SplitscreenOutlined, SplitscreenTwoTone, ViewStreamRounded, ViewStreamSharp } from '@mui/icons-material'
import { changeThemeShow, logOut } from '../redux/slices/adminSlice'
import { Link, useNavigate } from 'react-router-dom'
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { logOutA } from '../redux/slices/superAdminSlice'
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import { deleteAllSensors } from '../redux/slices/allSensorSlice'
import { deleteAllCollectors } from '../redux/slices/collectorsSlice'
import { deleteAllComments } from '../redux/slices/commentsSlice'
import { logOutF } from '../redux/slices/farmsSlice'
import { logOutL } from '../redux/slices/listDamSlice'
import { logOutC } from '../redux/slices/singleCattleSlice'
import { deleteAllCol } from '../redux/slices/singleCollectorSlice'
import { logOutS } from '../redux/slices/singleFarmSlice'
import { deleteSensor } from '../redux/slices/singleSensorSlice'
import { deleteWarn } from '../redux/slices/warningSlice'
import { logOutP } from '../redux/slices/pensSlice'
import { Badge, Switch, TextField } from '@mui/material'
import { logOutPP } from '../redux/slices/PensStatusSlice'
import Splitscreen from '@mui/icons-material/Splitscreen'
import { deleteTime } from '../redux/slices/timeSlice'
import apiService from '../api/ApiService'
import SearchResult from './SearchResult'
import SwitchComponent from './SwitchComponent'
const moment=require('moment-jalaali');

const NavBar=()=>{
    const {currentAdmin,statusCount,currentTheme}=useSelector(state=>state.p.admin)
    const [selectedDay, setSelectedDay] = useState();
    const {currentTimeDiff}=useSelector(state=>state.p.time)
    const [q,setQ]=useState(null)
    const [data,setData]=useState([])
    const {ToGG,isAllTimeOpen,openTime,openSearch,closeSearch,searchShow}=useGlobalContext()
    const navigate=useNavigate()
    const dispatch=useDispatch()
    const handleLogout=()=>{
        dispatch(logOutPP())
        dispatch(logOut())
        dispatch(logOutA())
        dispatch(deleteAllSensors())
        dispatch(deleteAllCollectors())
        dispatch(deleteAllComments())
        dispatch(logOutF())
        dispatch(logOutP())
        dispatch(logOutS())
        dispatch(deleteSensor())
        dispatch(logOutL())
        dispatch(logOutF())
        dispatch(logOutC())
        dispatch(deleteAllCol())
        dispatch(deleteWarn())
        dispatch(deleteTime())
        navigate('/')
    }
    const handleSearch=async(e)=>{
        e?.preventDefault()
        if(q){
            const data=JSON.stringify({
              "skip": -1,
              "take": -1,
              "fromDate": null,
              "toDate": null,
              "penIds":[],
              "statuses":[],
              "hasSensor":null,
              "lifeCycles":[],
              'number':+q
            })
              
              const res=await apiService.getAllCattles(currentAdmin?.id,data)
              setData(res.data.data)
              openSearch()
              }
              
      
      }
      
      useEffect(() => {
        const timeoutId = setTimeout(() => {
          if(q){
            handleSearch()
          }
        }, 900)
        return () => clearTimeout(timeoutId)
      }, [q])
        
    return <>
    <div className={S.NavCon}>
        <div className={S.UserCon}>
            <img className={S.UserConImg} src={farm}/>
            <div className={S.UserConTitle}>{currentAdmin?.farmName}</div>
            <form   className='d-flex justify-content-center align-items-center'>
        {/* <button onClick={openSearch}  type='button' className='searchBtn'>
            <Search/>
        </button> */}
        <div className='inputContainerSS4'>
            <input autoComplete="off" type="number"  className='inputSS4' value={q} onChange={(e)=>{
                setQ(e.target.value)
            }} placeholder="a" />
            <label for="" className={'labelSS d-flex justify-content-center align-items-center'} ><Search fontSize='small'/> جستجو دام </label>
            
        </div>
        
        </form>
            


        </div>

        <img className={S.Logo} style={{justifySelf:'center',margin:'0px auto'}} src={L}/>
        <img className={S.LogoS} style={{justifySelf:'center',margin:'0px auto'}} src={L}/>
        
        <div className='d-flex' style={{marginRight:'8px',gap:'20px',alignItems:'center'}}>
                
        <div className='logOutContainer' data-title='خروج' onClick={handleLogout}>  <ExitToAppRounded fontSize='large'/></div>
        <Link to={{ pathname: '/Status',search:'fromDash', state: { fromDash:true } }} className={`${S.TicketBadge}`}>
                <Badge color="success" badgeContent={statusCount>0?statusCount:'0'} max={99}>
        <ReportGmailerrorred fontSize='large'/>
      </Badge>
                </Link>
                <div className={S.StatusCons}>
           
            <div data-title={`${currentTimeDiff?.substring(0,16)}`} className={`${S.TicketBadge}`} onClick={openTime}>
                 <AddAlarmIcon fontSize='large'/>
                </div>
                
            </div>
        <div data-title='تغییر نحوه ی نمایش لیست ها' className={`switchBttn ${S.StatusCons} `}>
            <SwitchComponent/>
            </div>
            
            
            
        <div className='navIcon4' onClick={ToGG}>
  <span></span>
  <span></span>
  <span></span>
</div>
        </div>
        {searchShow&&<SearchResult data={data}/>}
    </div>
    
    </>
}
export default NavBar
